import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { LineItemSlotsProvider, LineItemCard, LineItemModels, GlassesPrescription, PrescriptionTable } from '@grandvisionhq/lib-visuals';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { QuantitySelector } from '../components/QuantitySelector.js';
import { DeliveryIndicatorContainer } from '../containers/DeliveryIndicatorContainer.js';

const VisualLineItemsContainer = ({ lineItems , readOnly  })=>{
    const intl = useIntl();
    const { isLineItemDeliveryEstimationDisabled  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            quantity: intl.getLabel('cart.item.quantity'),
            iconLeftEye: intl.getLabel('products.contactLenses.leftEye'),
            iconRightEye: intl.getLabel('products.contactLenses.rightEye'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            deliveredEvery: intl.getLabel('cart.delivery.frequency'),
            perBox: intl.getLabel('products.perBox'),
            configuration: intl.getLabel('account.order.detail.configuration'),
            prescription: intl.getLabel('account.order.detail.prescription'),
            subscriptionDetails: intl.getLabel('cart.item.subscription.title'),
            deliveryInterval: intl.getLabel('cart.item.subscription.deliveryInterval'),
            day: intl.getLabel('common.duration.day'),
            days: intl.getLabel('common.duration.days')
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem)=>{
        var ref;
        const baseProps = {
            labels,
            currency: intl.currency,
            discountPrice: lineItem.discountPrice ? lineItem.price : 0,
            relativeDiscount: lineItem.relativeDiscount,
            imagePath: lineItem.imageUrl,
            lineItemId: lineItem.lineItemId,
            price: lineItem.originalPrice || lineItem.price,
            quantity: lineItem.quantity,
            subtitle: lineItem.subtitle,
            title: lineItem.title,
            compactCard: false,
            hideDiscountSection: false
        };
        if ('bundleChildLineItems' in lineItem) {
            baseProps.bundleChildLineItems = lineItem.bundleChildLineItems;
        }
        const LineItemCardSlot = {
            QuantitySelector: !readOnly ? ()=>/*#__PURE__*/ React.createElement(QuantitySelector, {
                    hideQuantity: lineItem.type === 'CONTACT_LENS_BUNDLE',
                    lineItemId: lineItem.lineItemId,
                    readOnly: readOnly
                })
             : undefined,
            StockAndDelivery: ()=>!isLineItemDeliveryEstimationDisabled ? /*#__PURE__*/ React.createElement(DeliveryIndicatorContainer, {
                    lineItemId: lineItem.lineItemId
                }) : null
        };
        return /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
            key: lineItem.sku,
            slots: LineItemCardSlot
        }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: lineItem.sku,
            imageHref: lineItem.productUrl
        }, baseProps), 'prescription' in lineItem ? /*#__PURE__*/ React.createElement(LineItemCard.AccordionCardItem, {
            title: labels.prescription
        }, LineItemModels.isGlassesBundleLineItem(lineItem) ? /*#__PURE__*/ React.createElement(GlassesPrescription, {
            intl: intl,
            prescription: lineItem.prescription
        }) : /*#__PURE__*/ React.createElement(PrescriptionTable, {
            size: "narrow",
            orientation: "eyeSideTop",
            formatPrescription: true,
            prescription: swcHelpers.objectSpread({}, lineItem.prescription)
        })) : null, lineItem.isSubscription && ((ref = lineItem.subscriptionDetails) === null || ref === void 0 ? void 0 : ref.deliveryInterval) ? /*#__PURE__*/ React.createElement(LineItemCard.AccordionCardItem, {
            title: labels.subscriptionDetails,
            expanded: true
        }, /*#__PURE__*/ React.createElement(Text, {
            variant: "body-head"
        }, labels.deliveryInterval), /*#__PURE__*/ React.createElement(Text, null, `${lineItem.subscriptionDetails.deliveryInterval} ${lineItem.subscriptionDetails.deliveryInterval === 1 ? labels.day : labels.days}`)) : null));
    }));
};

export { VisualLineItemsContainer };
//# sourceMappingURL=VisualLineItemsContainer.js.map
